const actions = {
  ACCESS_CONSUMER_PORTAL: "ACCESS_CONSUMER_PORTAL",
  ACCESS_ADMIN_PORTAL: "ACCESS_ADMIN_PORTAL",
  ACCESS_COMPANY_LISTING: "ACCESS_COMPANY_LISTING",
  ACCESS_ADDRESS_SUMMARY: "ACCESS_ADDRESS_SUMMARY",
  ACCESS_ADD_NEW_COMPANY: "ADD_NEW_COMPANY",
  ACCESS_ADD_NEW_ADDRESS: "ADD_NEW_ADDRESS",
  ACCESS_EDIT_COMPANY: "ACCESS_EDIT_COMPANY",
  ACCESS_EDIT_ADDRESS: "ACCESS_EDIT_ADDRESS",
  ACCESS_VIEW_COMPANY: "ACCESS_VIEW_COMPANY",
  ACCESS_COMPANY_USER_LISTING: "ACCESS_COMPANY_USER_LISTING",
  ACCESS_COMPANY_PICKUPADDRESSES_LISTING:
    "ACCESS_COMPANY_PICKUPADDRESSES_LISTING",
  ACCESS_COMPANY_BILLINGADDRESSES_LISTING:
    "ACCESS_COMPANY_BILLINGADDRESSES_LISTING",
  ACCESS_ADD_LOGISTICS: "ACCESS_ADD_LOGISTICS",
  ACCESS_EDIT_LOGISTICS: "ACCESS_EDIT_LOGISTICS",
  ACCESS_VIEW_LOGISTICS: "ACCESS_VIEW_LOGISTICS",
  ACCESS_LOGISTICS_LISTING: "ACCESS_LOGISTICS_LISTING",
  ACCESS_ADD_LAB: "ACCESS_ADD_LAB",
  ACCESS_VIEW_LAB: "ACCESS_VIEW_LAB",
  ACCESS_EDIT_LAB: "ACCESS_EDIT_LAB",
  ACCESS_LAB_LISTING: "ACCESS_LAB_LISTING",
  ACCESS_ADD_TEST: "ACCESS_ADD_TEST",
  ACCESS_COMPANY_CATALOG_LISTING: "ACCESS_COMPANY_CATALOG_LISTING",
  ACCESS_MASTER_CATALOG: "ACCESS_MASTER_CATALOG",
  ACCESS_ORDER_LISTING: "ACCESS_ORDER_LISTING",
  ACCESS_USER_SUMMARY: "ACCESS_USER_SUMMARY",
  ACCESS_ADD_COMPANY_CATALOG: "ACCESS_ADD_COMPANY_CATALOG",
  ACCESS_EDIT_COMPANY_CATALOG: "ACCESS_EDIT_COMPANY_CATALOG",
  ACCESS_EDIT_TEST_PRICE_IN_COMPANY_CATALOG:
    "ACCESS_EDIT_TEST_PRICE_IN_COMPANY_CATALOG",
  ACCESS_REMOVE_TEST_FROM_COMPANY_CATALOG:
    "ACCESS_REMOVE_TEST_FROM_COMPANY_CATALOG",
  ACCESS_COMPANY_CATALOG: "ACCESS_COMPANY_CATALOG",
  ACCESS_EDIT_USER: "ACCESS_EDIT_USER",
  ACCESS_VIEW_USER_DETAILS: "ACCESS_VIEW_USER_DETAILS",
  ACCESS_ADD_USER: "ACCESS_ADD_USER",
  ACCESS_CATALOG_MANAGEMENT: "ACCESS_CATALOG_MANAGEMENT",
  ACCESS_LAB_PORTAL: "ACCESS_LAB_PORTAL",
  ACCESS_ANALYTICS: "ACCESS_ANALYTICS",
  BO_DOWNLOAD_PURCHASE_ORDER: "BO_DOWNLOAD_PURCHASE_ORDER",
  BO_ACCESS_ORDER_DETAILS: "BO_ACCESS_ORDER_DETAILS",
  BO_APPROVE_ORDER_PAYMENT: "BO_APPROVE_ORDER_PAYMENT",
  BO_APPROVE_PURCHASE_ORDER: "BO_APPROVE_PURCHASE_ORDER",
  BO_REGRET_ORDER: "BO_REGRET_ORDER",
  BO_UPDATE_ORDER_STATUS: "BO_UPDATE_ORDER_STATUS",
  BO_UPLOAD_REPORT: "BO_UPLOAD_REPORT",
  BO_DOWNLOAD_REPORT: "BO_DOWNLOAD_REPORT",
  BO_ADD_ORDER_INSTRUCTIONS: "BO_ADD_ORDER_INSTRUCTIONS",
  BO_ACCESS_ORDER_INSTRUCTIONS: "BO_ACCESS_ORDER_INSTRUCTIONS",
  BO_ACCESS_PACKAGE_LISTING: "BO_ACCESS_PACKAGE_LISTING",
  BO_EDIT_PACKAGE: "BO_EDIT_PACKAGE",
  BO_ACCESS_PACAKGE_DETAILS: "BO_ACCESS_PACAKGE_DETAILS",
  BO_ADD_PACKAGE: "BO_ADD_PACKAGE",
  BO_ACCESS_BOOK_TEST: "BO_ACCESS_BOOK_TEST",
  BO_UPDATE_ORDER_LAB: "BO_UPDATE_ORDER_LAB",
  BO_UPDATE_ORDER_LOGISTICS: "BO_UPDATE_ORDER_LOGISTICS",
  BO_ACCESS_PAYMENT_REMINDER: "BO_ACCESS_PAYMENT_REMINDER",
  BO_CREATE_SERVICE_REQUEST: "BO_CREATE_SERVICE_REQUEST",
  BO_ACCESS_ASSETS_LISTING: "BO_ACCESS_ASSETS_LISTING",
  BO_ACCESS_SAMPLER_LISTING: "BO_ACCESS_SAMPLER_LISTING",
  BO_DASHBOARD_NEW: "BO_DASHBOARD_NEW",
  BO_DASHBOARD_NEW_SAMPLING: "BO_DASHBOARD_NEW_SAMPLING",
  BO_DASHBOARD_NEW_COMMODITY: "BO_DASHBOARD_NEW_COMMODITY",
  BO_DASHBOARD_NEW_TESTING: "BO_DASHBOARD_NEW_TESTING",
  BO_ACCESS_ASSETS_DETAIL_VIEW: "BO_ACCESS_ASSETS_DETAIL_VIEW",
  BO_DASHBOARD_NEW_TAT:"BO_DASHBOARD_NEW_TAT",
  BO_DASHBOARD_NEW_SAMPLING_COVERAGE: "BO_DASHBOARD_NEW_SAMPLING_COVERAGE",
  BO_DASHBOARD_NEW_REPORT: "BO_DASHBOARD_NEW_REPORT",
  BO_DASHBOARD_NEW_REGRET: "BO_DASHBOARD_NEW_REGRET",
  BO_DASHBOARD_NEW_COMPLIANCE:"ACTIONS.BO_DASHBOARD_NEW_COMPLIANCE"
};

module.exports = actions;
